"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Utility classes for shared upload data
 */
var uploadUtils = Object.freeze({
  DOCUMENT_MAX_SIZE: 15000000,
  DOCUMENT_MIN_SIZE: 1000
});
var _default = uploadUtils;
exports.default = _default;
//# sourceMappingURL=upload.js.map